import { render, staticRenderFns } from "./SurveyEdit.vue?vue&type=template&id=5aed8b83"
import script from "./SurveyEdit.vue?vue&type=script&lang=ts"
export * from "./SurveyEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports